import 'css-chunksrc/client/pages/taskPage/details/styles.scss';export default {
  "details": "_details_1btnz_1",
  "name": "_name_1btnz_5",
  "input": "_input_1btnz_15",
  "description": "_description_1btnz_25",
  "label": "_label_1btnz_29",
  "paragraph": "_paragraph_1btnz_39",
  "advancement": "_advancement_1btnz_49",
  "percentage": "_percentage_1btnz_56",
  "progressBar": "_progressBar_1btnz_65",
  "percentageText": "_percentageText_1btnz_70",
  "advancementLabel": "_advancementLabel_1btnz_79",
  "descriptionMaxChars": "_descriptionMaxChars_1btnz_86",
  "loader": "_loader_1btnz_91",
  "loaderMain": "_loaderMain_1btnz_99",
  "invalid": "_invalid_1btnz_106",
  "container": "_container_1btnz_114",
  "item": "_item_1btnz_121",
  "value": "_value_1btnz_132"
};